import React from 'react';

const Button = ({ children, type, mobile, onClick, className }) => {
  const classes = ['button', className];

  if (mobile) {
    classes.push('button--mobile-100');
  }

  return (
    <button className={classes.join(' ')} type={type} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
